module.exports = __webpack_public_path__ + "img/companyIntro12.68991742.png";